// extracted by mini-css-extract-plugin
export var pillWrapper = "_p2-0";
export var showOverflow = "_p2-1";